export { ResearchComparisonPage } from './ResearchComparison';
